/**
 * Standard FormKit tel input with added validation (see `features`)
 * Exported from formkit per https://formkit.com/guides/export-and-restructure-inputs
 */

import { FormKitTypeDefinition, createMessage } from '@formkit/core'
import {
  outer,
  inner,
  wrapper,
  label,
  help,
  messages,
  message,
  icon,
  prefix,
  suffix,
  textInput,
} from '@formkit/inputs'

import {
  validPhone,
} from '@grantstreet/psc-js/utils/validators.js'

/**
 * Input definition for a text.
 * @public
 */
export const gsgPhone: FormKitTypeDefinition = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: outer(
    wrapper(
      label('$label'),
      inner(
        icon('prefix', 'label'),
        prefix(),
        textInput(),
        suffix(),
        icon('suffix'),
      ),
    ),
    help('$help'),
    messages(message('$message.value')),
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: 'input',
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: 'text',
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Forces node.props.type to be this explicit value.
   */
  forceTypeProp: 'tel',
  /**
   * Additional features that should be added to your input
   */
  features: [(node) => {
    node.hook.commit((payload, next) => {
      if (typeof payload === 'string' || typeof payload === 'number') {
        if (!validPhone(payload)) {
          node.store.set(createMessage({
            key: 'phone',
            type: 'validation',
            blocking: true,
            visible: true,

            // XXX: We will need to translate this at some point.
            // Can select a value based on node.config.rootConfig?.locale
            value: 'Phone number must have 7-15 digits and can only contain numbers, hyphens, parentheses, spaces, and a plus symbol.',
          }))
        }
        else {
          node.store.remove('phone')
        }
      }
      return next(payload)
    })
  }],
  /**
   * The key used to memoize the schema (see CONTRIBUTING.md).
   */
  schemaMemoKey: 'nw2lq3jnjd',
}
